const en_US = {
    'tabs.header.message': "messageCenter",
    'tabs.header.task':"taskCenter",
}
export default en_US;


// WEBPACK FOOTER //
// ./src/components/Intl/locales/en.js